export const teacherOrAdminLoggedAndIsAuthor = [
  {
    key: "1",
    labelPT: "Excluir",
    labelEN: "Delete",
    icon: "md-deleteoutline-round",
    method: "deleteComment",
  },
  {
    key: "2",
    labelPT: "Editar",
    labelEN: "Close topic",
    icon: "md-edit-outlined",
    method: "editComment",
  },
];

export const teatcherOrAdminLoggedAndIsNotAuthor = [
  {
    key: "1",
    labelPT: "Excluir",
    labelEN: "Delete",
    icon: "md-deleteoutline-round",
    method: "deleteComment",
  },
];

export const studentLoggedAndIsAuthor = [
  {
    key: "1",
    labelPT: "Excluir",
    labelEN: "Delete",
    icon: "md-deleteoutline-round",
    method: "deleteComment",
  },
  {
    key: "2",
    labelPT: "Editar",
    labelEN: "Close topic",
    icon: "md-edit-outlined",
    method: "editComment",
  },
];

export const studentLoggedAndIsNotAuthor = [
  {
    key: "1",
    labelPT: "Denunciar",
    labelEN: "Report",
    icon: "md-outlinedflag-round",
    method: "reportComment",
  },
];

export const studentLoggedAndIsAuthorButTopicResolved = [
  {
    key: "1",
    labelPT: "Excluir",
    labelEN: "Delete",
    icon: "md-deleteoutline-round",
    method: "deleteComment",
  },
];

export interface commentOptions  {
  key: string
  labelPT: string
  labelEN: string
  icon: string
  method: string
}